// extracted by mini-css-extract-plugin
module.exports = {"panel-home":"Home_panel-home__ogDs1","is-btn":"Home_is-btn__1Rq41"};